import { render, staticRenderFns } from "./CompVoiceChat.vue?vue&type=template&id=55ea455c&scoped=true"
import script from "./CompVoiceChat.vue?vue&type=script&lang=js"
export * from "./CompVoiceChat.vue?vue&type=script&lang=js"
import style0 from "./CompVoiceChat.vue?vue&type=style&index=0&id=55ea455c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ea455c",
  null
  
)

export default component.exports